import { formatCurrency } from './formatCurrency';

export const formatCurrencyOrMock = (
  value: number | undefined,
  loadingText: string,
  loading: boolean,
) =>
  value === undefined || loading
    ? formatCurrency(
        Number(
          loadingText
            .split('')
            .map((s) => (s === ',' ? '.' : 1))
            .join(''),
        ),
        2,
      ).replace(/1/g, '#')
    : formatCurrency(value);
